import { defineStore } from 'pinia';
import { ref, reactive, computed } from 'vue'
import { sendAiDialogue, stopResponding, getConversationsList, healderSendAudioMessage } from '@/service/AI/index';
import { getLocalStorage, STORE_KEYS, userID } from '@/tool/localStore';
import { useGStatusStore } from './G-Status'
export const useAiDialogueStore = defineStore('aiDialogue', () => {
  const gStatusStore = useGStatusStore()
  // 中断控制器
  let currentAbortController = ref();
  // 当前会话的 conversation_id
  let conversationId = ref(null)
  // ai对话列表数据
  let dialogueLists = reactive([
    // {
    //   user: {
    //     questioning: { query: '中文字幕提供' }, submitType: "audio", ai: {
    //       summary: '',
    //       answer: '',
    //       reqTimeOutMessage: ''
    //     }
    //   }
    // }




  ])


  // 流式对话的 id，用于暂停会话
  let taskId = ref(null)
  // 请求的实例
  const request = ref({});
  // 发送消息超时提示
  let reqTimeOut = ref(5000);
  let reqTimeOutMessage = ref('')
  // 保持取消方法
  let abortController = null;
  // 判断是否为json
  function isJsonStringified(data) {
    if (typeof data !== 'string') return false;
    try {
      JSON.parse(data);
      return true;
    } catch (error) {
      return false;
    }
  };

  // 额外带个ai的参数，主要是用于页面展示，和ai对话历史数据回显
  const reflectAIChatHistory = (extra, propt = '', data) => {
    let _extra = JSON.stringify(extra);
    let _data = isJsonStringified(data) ? data : JSON.stringify(data);
    return ` (这个小括号里面的内容不要做分析，也不要做解读，直接忽略 $start$ ${_extra} $end$) ${propt}: \n ${_data} `
  };

  // 提示语
  const defaultTipsText = {
    media: '已收到您提交的富媒体信息',
    form: '已收到您提交的养殖记录，您的每一次反馈，将是我们优化提升基地效益的前进动力。',
    daily: '⚠ 当前服务中断，请耐心等待恢复',
    dialogue: '⚠ 当前服务中断，请耐心等待恢复',
    audio: '⚠ 当前服务中断，请耐心等待恢复',
    training: [
      '太棒啦，您已完成本次培训记录上报！您的及时参与让培训数据更完整，这既是个人成长的有力证明，也为团队的培训体系完善贡献了重要力量',
      '恭喜您顺利完成本次培训记录上报！您的高效配合让培训数据统计更及时，这不仅是个人学习轨迹的清晰印记，也为团队优化培训计划提供了关键参考呢',
      '恭喜您完成培训记录上报！您的及时反馈让我们能更快地掌握培训效果，这份记录既是您的学习凭证，也为团队优化培训内容提供了重要依据，谢谢啦',
      '您已顺利上报培训记录，由衷感谢！这份记录是连接个人学习与团队发展的关键纽带 —— 既帮您沉淀培训精华，又为团队分析短板、强化优势提供了第一手资料，它的存在让我们的培训工作更有方向、更有价值。',
      '恭喜您完成培训记录上报，感谢您的重视！这份记录的重要性体现在：于个人，是知识内化的 “催化剂”，助力将所学转化为所用；于团队，是资源优化的 “指南针”，让培训投入产出比更高。您的参与让这份价值得以实现。',
      '培训记录上报成功！衷心感谢您的配合。要知道，这份记录不仅是您个人学习历程的权威存档，能帮您清晰追溯成长轨迹；更是团队掌握培训实效、调整资源投入的重要凭证，您的认真对待让我们的培训工作更具针对性。'
    ],
    hygiene: [
      '温馨提示：您已完成卫生清洁记录上报，感谢支持！它的价值在于：既是确保清洁操作规范延续的凭证，也是团队追溯卫生历史、总结经验教训的重要工具，您的及时反馈让每一次清洁都更有质量。',
      '清洁记录已成功提交，感谢您的高度负责！对卫生工作来说，这份记录是 “保养手册”，记录着维持环境良好卫生状态的每一步；对团队而言，是实现环境可持续洁净的重要保障，您的配合让清洁工作更具意义。',
      '温馨告知：卫生清洁记录已顺利提交，感谢您的投入！这份记录的重要性在于：它是保障环境各项卫生指标达标的基础，也是避免卫生隐患滋生的关键，您的及时反馈让清洁工作更有方向。',
      '恭喜您完成清洁记录上报，感谢您的认真执行！这份记录对卫生工作至关重要：它是预防卫生问题、减少健康风险的基础，也是提升环境品质的关键，您的认真填写让清洁工作的意义更加凸显。',
      '您已成功上报卫生清洁记录，万分感谢！这份记录是守护环境持续洁净的 “卫士”，既记录了清洁的每一个关键步骤，也为后续清洁安排提供了清晰指引，您的及时提交让卫生安全更有底气。',
      '恭喜您完成清洁记录上报，感谢您的重视！这份记录的重要性体现在：于清洁工作，是流程规范的 “说明书”；于环境安全，是风险防控的 “警示灯”，您的参与让这份价值得以实现。'
    ],
    handover: ['据与待办事项，是工作延续的 “导航图”，更是确保养殖环节不脱节的重要保障，您的付出为养殖安全添了份安心。',
      '恭喜完成交接班记录上报，感谢您的积极参与！RAS 养殖交接班记录，既是您严谨工作的见证，能帮接班同事快速上手；更是团队把控养殖全过程、及时处理问题的核心依据，您的认真让养殖管理更高效。',
      '交接班记录已成功提交，感谢您的认真对待！对 RAS 养殖工作而言，这份记录是 “接力棒”，传递着每一个关键信息；对团队来说，是提升工作协同性、保障养殖稳定的重要参考，您的配合让养殖环节更可控。',
      '恭喜完成交接班记录上报，感谢您的积极配合！养殖交接班记录，既是您履行岗位职责的证明，也为团队评估交接成效、改进工作方法提供了第一手资料，您的付出让养殖系统更稳定。',
      '交接班记录已成功提交，感谢您的高度负责！对养殖工作来说，这份记录是 “工作日记”，记录着维持养殖系统良好运行的每一步；对团队而言，是实现可持续发展的重要保障，您的配合让交接工作更具意义。',
      '温馨提示：您已完成养殖交接班记录上报，感谢支持！它的重要性不言而喻：是确保养殖数据连贯、操作规范的基础，也是应对突发情况的重要凭证，您的及时反馈让每一份交接都有实际意义。'
    ]
  };

  // 发送消息
  const sendMessage = (query, callback, submitType, tipsText, sendType) => {
    console.log('提交类型', submitType);
    // 卫生、培训、交接不需要分析，直接提示
    if (submitType == 'training' || submitType == 'hygiene' || submitType == 'handover') {
      reqTimeOut.value = 1;

      // 获取提示文本，如果是数组则随机选择一个
      let tipText = tipsText?.[submitType] || defaultTipsText[submitType];
      if (Array.isArray(tipText)) {
        const randomIndex = Math.floor(Math.random() * tipText.length);
        tipText = tipText[randomIndex];
      }
      reqTimeOutMessage.value = tipText;

    }

    // 判断提交的数据类型,更改响应时间
    if (submitType == 'media') { //媒体
      reqTimeOut.value = 45000;
      reqTimeOutMessage.value = tipsText?.[submitType] || defaultTipsText[submitType]
    };
    if (submitType == 'form') { //上报的数据
      reqTimeOut.value = 40000;
      reqTimeOutMessage.value = tipsText?.[submitType] || defaultTipsText[submitType]
    };
    if (submitType == 'daily' || submitType == 'dialogue') {
      reqTimeOut.value = 45000;
      reqTimeOutMessage.value = tipsText?.[submitType] || defaultTipsText[submitType]
    };
    if (submitType == 'audio') {
      console.log('提交类型', submitType);
      reqTimeOut.value = 60000;
      reqTimeOutMessage.value = tipsText?.[submitType] || defaultTipsText[submitType]
    }
    // lü

    // 新增：创建 AbortController 实例
    const abortController = new AbortController();
    const { signal } = abortController;

    let isSummaryStarted = false;
    let summaryContent = '';
    let isSummaryEnded = false;
    let answerContent = '';

    gStatusStore.updateIsAnswering(true);

    // push一个当前会话对象
    dialogueLists.push({
      user: { questioning: query, submitType },
      ai: {
        summary: '',
        answer: '',
        reqTimeOutMessage: ''
      }
    });

    const lastDialogue = dialogueLists[dialogueLists.length - 1].ai;
    let hasReceivedData = false; // 标记是否接收到有效数据

    let sendPromise = null;

    new Promise((resolve, reject) => {
      gStatusStore.updateButtomMenuBarVisible(false)
      gStatusStore.updateIsMedia(false);
      // updateMedium(false);
      // 语音转文字后的回显
      if (sendType == "audio") {
        sendPromise = new Promise((res, rej) => {
          const startTime = Date.now();
          request.value = healderSendAudioMessage('/overviewapi/overview_bot', { ...query, signal }, (err, data) => {
            if (err) {
              console.log('录音错误', err);
              if (err.message && err.message.includes('abort')) {
                return rej({ message: 'abort' });
              };
              return rej(err);
            };

            // 新增：计算剩余时间
            const elapsedTime = Date.now() - startTime;
            const isTimeout = elapsedTime >= reqTimeOut.value;
            try {
              // 修改后的判断逻辑
              console.log('修改后的判断逻辑', isTimeout);
              if (typeof data !== 'object' || data === null) {
                // 仅在超时且数据不符合时才抛出错误
                if (isTimeout) {
                  return rej({ message: 'Request timeout' });
                }
                // 否则不处理，继续等待
                return;
              };

              // console.log('查看数据', data?.form_data);
              if (data?.form_data) callback?.(data.form_data, 'form');
              if (data?.content) {
                lastDialogue.answer += data?.content;

              } else if (data?.done && !data?.content) {
                gStatusStore.updateIsAnswering(false);
                taskId.value = null;

                callback?.(lastDialogue);
                res(data);
                hasReceivedData = true; // 标记已接收到数据
              }
            } catch (error) {
              console.log('处理数据错误~', error);
              rej(error);
            }
          })

          console.log(' audio返回值', request.value);

        });
      } else {
        // 发送对话promise
        sendPromise = new Promise((res, rej) => {
          const startTime = Date.now(); // 新增：记录请求开始时间

          request.value = sendAiDialogue('/chat-messages', {
            query,
            conversation_id: conversationId.value,
            signal,
            user: getLocalStorage(userID)
          }, (err, data) => {
            if (err) {
              if (err.message && err.message.includes('abort')) {
                return rej({ message: 'abort' });
              };

              console.log('发送对话错误', err);
              return rej(err);
            }

            // 新增：计算剩余时间
            const elapsedTime = Date.now() - startTime;
            const isTimeout = elapsedTime >= reqTimeOut.value;

            try {
              // 修改后的判断逻辑
              if (typeof data !== 'object' || data === null) {
                // 仅在超时且数据不符合时才抛出错误
                if (isTimeout) {
                  return rej({ message: 'Request timeout' });
                }
                // 否则不处理，继续等待
                return;
              };

              let answer = data.answer || '';
              const summaryStartIndex = answer.indexOf('</summary>');
              const summaryEndIndex = answer.indexOf('</details>');

              if (summaryStartIndex !== -1) {
                isSummaryStarted = true;
                answer = answer.slice(summaryStartIndex + '</summary>'.length);
                taskId.value = data.task_id;
              }

              if (summaryEndIndex !== -1) {
                isSummaryEnded = true;
                summaryContent = answer.slice(0, summaryEndIndex);
                answerContent = answer.slice(summaryEndIndex + '</details>'.length);
                answer = summaryContent + answerContent;
              }

              // 更新对话内容
              if (isSummaryStarted && !isSummaryEnded) {
                lastDialogue.summary += answer;
              } else if (isSummaryStarted && isSummaryEnded && data.event !== 'message_end') {
                lastDialogue.answer += answer;
              } else if (isSummaryStarted && isSummaryEnded && data.event === 'message_end') {
                gStatusStore.updateIsAnswering(false);
                conversationId.value = data.conversation_id;
                taskId.value = null;
                console.log('对话结束', dialogueLists);
                callback?.();
              }

              hasReceivedData = true; // 标记已接收到数据

              if (data.event === 'message_end') {
                res(data); // 流式传输完成时解析sendPromise
              }
            } catch (error) {
              console.log('处理数据错误~', error);
              rej(error);
            }
          });
          console.log(' request.value', request.value);
          // 保存abort方法

        });

      }






      // 语音转文字（成功负责后端开发 ）


      // 创建超时Promise
      const timeoutPromise = new Promise((_, rej) => {
        console.log('超时', hasReceivedData);
        console.log('reqTimeOut.value', reqTimeOut.value);
        const timeoutId = setTimeout(() => {
          if (!hasReceivedData) {
            rej(new Error('Request timeout'));
          }
        }, reqTimeOut.value);

        // 监听 AbortController 的中止信号，立即清除超时
        signal.addEventListener('abort', () => {
          clearTimeout(timeoutId);
        });
      });

      // 新增：监听 AbortController 的中止信号，触发 Promise.race 的中断
      const abortPromise = new Promise((_, rej) => {
        signal.addEventListener('abort', () => {
          rej(new Error('abort'));
        });
      });

      console.log('超时', timeoutPromise);
      console.log('说动关闭', abortPromise);

      // 使用Promise.race竞争
      Promise.race([sendPromise, timeoutPromise, abortPromise])
        .then(data => {
          console.log('使用Promise', data);
          resolve();
        })
        .catch(error => {
          if (error.message === 'Request timeout') {
            // 仅在未收到数据时设置超时消息
            if (!hasReceivedData) {
              lastDialogue.answer = reqTimeOutMessage.value;
              lastDialogue.reqTimeOutMessage = reqTimeOutMessage.value;
              request.value.abort()
              gStatusStore.updateIsAnswering(false);
            }

          } else if (error.message === 'abort') { // 新增中止处理
            // 当检测到中止时，使用 stopCurrentSession 设置的 reqTimeOutMessage
            // 立即设置 reqTimeOutMessage
            lastDialogue.reqTimeOutMessage = reqTimeOutMessage.value;
            lastDialogue.answer = reqTimeOutMessage.value;
            request.value.abort()
            gStatusStore.updateIsAnswering(false);
          } else {
            request.value.abort()
            console.error('其他错误: 333', error);
            reject(error);
          }
        });
    });
    // 返回 AbortController 以便外部调用中止
    currentAbortController.value = abortController;

  };


  // 暂停会话
  const stopCurrentSession = async () => {
    // 设置中止时的提示信息
    reqTimeOutMessage.value = '回答已停止';
    console.log('currentAbortController.value', currentAbortController.value);
    // 立即触发 AbortController 的中止
    if (currentAbortController.value) {
      currentAbortController.value.abort();
    }

    // 确保对话状态被重置

    gStatusStore.updateIsAnswering(false);
    return await stopResponding(taskId.value, { user: getLocalStorage(userID) });
  };

  // 获取历史会话记录
  const conversationsList = async () => {
    let userId = getLocalStorage(userID);
    console.log('userIduserId', userId);
    let result = await getConversationsList(userId);
    console.log('获取历史会话记录', result);
  };


  return {
    sendMessage,
    dialogueLists,
    stopCurrentSession,
    reflectAIChatHistory,
    conversationsList
  }
})



